
    import '/opt/buildhome/repo/packages/x/docs/x-markdown/playground.en-US.md?watch=parent';
    export const toc = [{"id":"docs-x-markdown-playground-demo-playground","depth":3,"title":"XMarkdown Playground"}];
export const frontmatter = {"title":"Playground","toc":"menu","filename":"docs/x-markdown/playground.en-US.md","lastUpdated":1773710526000,"order":2.1,"__autoDescription":true};